// src/store/index.js
import Vue from 'vue'
import Vuex from 'vuex' // 使用 Vuex 3
Vue.use(Vuex) // 安装 Vuex

export default new Vuex.Store({
  state: {
    isLoggedIn: false,
    token: null
  },
  mutations: {
    SET_LOGIN_STATUS(state, status) {
      state.isLoggedIn = status
    },
    SET_TOKEN(state, token) {
      state.token = token
    }
  },
  actions: {
    login({ commit }, token) {
      commit('SET_LOGIN_STATUS', true)
      commit('SET_TOKEN', token)
      localStorage.setItem('authToken', token)
    },
    logout({ commit }) {
      commit('SET_LOGIN_STATUS', false)
      commit('SET_TOKEN', null)
      localStorage.removeItem('authToken')
    },
    initializeAuth({ commit }, token) {
      commit('SET_LOGIN_STATUS', true)
      commit('SET_TOKEN', token)
    }
  }
})